
import 'select2/dist/js/select2'

export default class Select {

    constructor() {
        this.settings = {
            el: document.querySelectorAll('.js-select, .gfield_select')
        };

        this.bindUIActions();
    }

    bindUIActions() {

        $(this.settings.el).select2({
            minimumResultsForSearch: Infinity, // Hide the search box
            width: 'resolve'
        });

        $('.select2-container').css('width', '100%');

    }

};

new Select();
